<div class="pagination">
  <pagination-template #p="paginationApi" [id]="config.id" (pageChange)="setCurrentPage($event)">
    <ul class="custom-pagination pagination">
      <li class="pagination-previous" [class.circle]="!!circle" [class.disabled]="p.isFirstPage()" *ngIf="!!p.pages"
        (click)="previousPage(p.isFirstPage())">
        <a>
          <img src="assets/icon/left-arrow.svg" height="24" width="24">
        </a>
      </li>
      <li *ngFor="let page of visiblePages" [class.active]="config.currentPage === page">
        <ng-container *ngIf="page !== '...'; else ellipsisTpl">
          <a (click)="setCurrentPage(page)" *ngIf="config.currentPage !== page">
            <span>{{ page }}</span>
          </a>
          <a *ngIf="config.currentPage === page">
            <span>{{ page }}</span>
          </a>
        </ng-container>
      </li>
      <li class="pagination-next" [class.circle]="!!circle" [class.disabled]="p.isLastPage()" *ngIf="!!p.pages"
        (click)="nextPage(p.isLastPage())">
        <a>
          <img src="assets/icon/right-arrow.svg" height="24" width="24">
        </a>
      </li>
    </ul>
  </pagination-template>

  <ng-template #ellipsisTpl>
    <a>
      <span class="ellipsis">...</span>
    </a>
  </ng-template>

  <div class="dropdown-container" *ngIf="showPerPageNumber">
    <p class="smallest dropdown-label">Result per page</p>
    <div class="per-page-dropdown" [class.open]="openDropDown" (blur)="openDropDown = false" tabindex="0">
      <div class="dropdown-placeholder" (click)="openDropDown = !openDropDown">
        <p class="smaller">{{config.itemsPerPage}}</p>
        <img src="assets/icon/primary-arrow-down.svg" alt="arrow" height="24" width="24">
      </div>

      <div class="dropdown-list">
        <div class="dropdown-item" [class.selected]="config.itemsPerPage === count" *ngFor="let count of itemsPerPage"
          (click)="setPerPage(count)">
          <p class="smaller">{{count}}</p>
        </div>
      </div>
    </div>
  </div>
</div>
